import { StorageItems } from '../../shared/constants/app';
import { addItemToLocalstorage, getItemFromLocalStorage } from './storage';

export const getDeviceID = (): string => {
  const existing = getItemFromLocalStorage(StorageItems.DEVICE_ID, 'string');
  if (existing) return existing;

  const deviceId =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

  addItemToLocalstorage(StorageItems.DEVICE_ID, deviceId);
  return deviceId;
};
